<script>
    export let options;
    export let placeholder;
    export let current_state;

    let selected;

    const extractBaseUrl = () => {
        const origin = window.location.origin;
        const pathSegments = window.location.pathname.split('/');
        const firstTwoSegments = pathSegments.slice(1, 3).join('/');

        const result = [origin, firstTwoSegments].join('/');
        return result;
    };

    const filterRedirect = () => {
        const baseUrl = extractBaseUrl();
        window.location = `${baseUrl}/?state=${selected}`;
    };
</script>

<div>
    <select bind:value={selected} on:change={filterRedirect}>
        <option disabled>{placeholder}</option>
        {#each options as st}
            <option value={st.st} selected={current_state && current_state === st.st.toLowerCase() ? 'selected' : ''}
                >{st.name}</option
            >
        {/each}
    </select>
</div>
